import React, {FC} from 'react';
import classNames from 'classnames';
import {useContextRemaining} from 'components/useHolder/remaining';

import Calendar from './svgs/calendar.inline.svg';
import Clipboard from './svgs/clipboard.inline.svg';
import MapPin from './svgs/map-pin.inline.svg';

import * as styles from './styles.module.scss';

export interface ApptProps {
	id: string;
	datetime: string;
	product: string;
	productID: string;
	location?: string;
	region?: string;
	address: string;
}

interface ApptDetails {
	className?: string;
	details: ApptProps;
	countdown?: boolean;
}

const ApptDetails: FC<ApptDetails> = ({
	className,
	countdown = true,
	details,
}) => {
	const remaining = useContextRemaining();
	return (
		<div className={classNames(className, styles.wrapper)}>
			<div className={styles.title}>Appointment details</div>
			{countdown && (
				<div className={styles.remaining}>
					<span>Your reservation is being</span>
					<span>held for {remaining}</span>
				</div>
			)}
			<div className={styles.details}>
				<span>
					<Calendar />
					{details.datetime}
				</span>
				<span>
					<Clipboard />
					{details.product}
				</span>
				<span className={styles.map}>
					<MapPin />
					<div className={styles.loc}>{details.location}</div>
					<div className={styles.addr}>{details.address}</div>
				</span>
			</div>
		</div>
	);
};

export default ApptDetails;
